import { useLocation, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Lock } from "lucide-react";
import { LOGO_URL } from "../lib/api";
import Seo from "../components/Seo";

export default function AdminLogin() {
  const { login } = useAuth();
  const location = useLocation();
  const error = location.state?.error;

  return (
    <div className="min-h-[80vh] flex items-center justify-center bg-stone-50 px-6 py-16">
      <Seo title="Admin Login" noindex path="/admin/login" />
      <div className="w-full max-w-md bg-white border border-gray-200 rounded-2xl p-10 text-center">
        <img src={LOGO_URL} alt="Gens Realty" className="h-14 w-14 object-contain mx-auto mb-5" />
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#E63946] mb-3">Admin Portal</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight">Sign in to continue</h1>
        <p className="text-sm text-gray-500 mt-3 mb-8 leading-relaxed">
          Only whitelisted Gens Realty staff can access the admin dashboard. Sign in with your Google account.
        </p>

        {error && (
          <div className="mb-4 text-xs text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">
            {error}
          </div>
        )}

        <button
          onClick={login}
          className="w-full flex items-center justify-center gap-3 bg-[#1A1A1A] hover:bg-black text-white py-3.5 rounded-md font-semibold text-sm transition-colors"
          data-testid="admin-google-signin"
        >
          <svg className="w-5 h-5" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.3 29.2 35 24 35c-6.1 0-11-4.9-11-11s4.9-11 11-11c2.8 0 5.4 1.1 7.4 2.8l5.7-5.7C33.6 6.5 29 4.5 24 4.5 13.2 4.5 4.5 13.2 4.5 24S13.2 43.5 24 43.5 43.5 34.8 43.5 24c0-1.2-.1-2.4-.4-3.5z"/>
            <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16.1 19 13 24 13c2.8 0 5.4 1.1 7.4 2.8l5.7-5.7C33.6 6.5 29 4.5 24 4.5c-7.5 0-14 4.3-17.7 10.2z"/>
            <path fill="#4CAF50" d="M24 43.5c5 0 9.5-1.9 12.9-5l-6-4.9c-1.8 1.2-4.1 2-7 2-5.2 0-9.6-3.3-11.2-8l-6.5 5C8.9 39.2 15.8 43.5 24 43.5z"/>
            <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.3 4.1-4.3 5.5l6 4.9c-.4.4 6.6-4.8 6.6-14.4 0-1.2-.1-2.4-.4-3.5z"/>
          </svg>
          Sign in with Google
        </button>

        <div className="mt-6 text-xs text-gray-400 flex items-center justify-center gap-2">
          <Lock className="w-3.5 h-3.5" />
          Secure · Emergent-managed OAuth
        </div>

        <div className="mt-8 pt-6 border-t border-gray-100 text-xs text-gray-500">
          <Link to="/" className="hover:text-[#E63946]">← Back to public site</Link>
        </div>
      </div>
    </div>
  );
}
